// Collection Filter JS
const collection = document.querySelector('.collection-content_area');
if (collection) {
  const toggler = collection.querySelector('.aside-toggler');
  const aside = collection.querySelector('.facets-wrapper');

  toggler.addEventListener('click', function(e) {
      aside.classList.toggle('active');
  });
}


const all_btns = document.querySelectorAll(".product_selector button");
all_btns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
        const product_id = e.target.dataset.product;
        const all_products = document.querySelectorAll(".custom_fetured_product");

        all_products.forEach((product) => {
            product.classList.add("hidden");
        });

        const current_product = document.querySelector(`.custom_fetured_product[data-product="${product_id}"]`);
        current_product.classList.remove("hidden");
    });
});
